var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 114C188.709 86.4283 165.27 130.934 162.763 154.629C162.634 155.847 161.461 156.719 160.256 156.5C103.666 146.211 91.4362 190.687 92.5 204.5C97.2833 266.611 164.277 267.016 185.684 242.532C186.486 241.615 187.905 241.513 188.766 242.374L290.541 344.037C291.11 344.605 291.27 345.487 290.975 346.235C268.597 403.022 307.786 421.746 330.354 424C381.158 424 389.155 387.341 381.557 366.099C381.021 364.601 382.278 362.964 383.861 363.108C440.829 368.293 440.439 308.456 421.742 289.112C399.014 263.24 365.916 277.053 350.85 288.058C350.04 288.649 348.916 288.585 348.202 287.881L243.039 184.163C242.284 183.419 242.253 182.206 242.932 181.391C264.198 155.896 256.11 128.231 235.5 114Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.204 179.516C136.681 178.072 116.831 187.224 118.176 205.338",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.71 128.661C199.663 127.624 184.71 142.66 187.699 154.948",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.03 373.506C360.474 383.029 351.322 402.879 333.209 401.534",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M409.886 312C410.923 320.047 395.886 335 383.599 332.011",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/정형외과_none.dcaf11f950f315a8343ac43345e90368.svg";
export { ForwardRef as ReactComponent };